/* eslint-disable no-unused-vars */
import { restManager } from '@/plugin/restManager.js';
import i18nMixin from '@/mixins/i18n.mixin.js';
import { convertFlatMetricsToTree } from '../../containers/utils/utils';
import { scpmUtil } from '@/utils/scpmUtil.js';
const prefix = process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH;
const API = {
  productsConditions: `${prefix}/cloudmonitorings/product/v1/console/products/conditions` //상품 필드 조회
};

const handleSearchCondition = (params, res) => {
  const conditionTypes = {
    eventStatus: ['productName'],
    eventSetting: ['metricName', 'productName']
  };
  Object.entries(conditionTypes).forEach(([key, value]) => {
    if (
      params.conditionType === key &&
      res.searchList &&
      Object.keys(res.searchList).some((key) => value.includes(key))
    ) {
      value.forEach((val) => delete res.searchList[val]);
    }
  });
  return res;
};
const ignoreErrors = ['ResourceAlreadyExists', 'InvalidQueryDtValue'];
export default {
  namespaced: true,
  state: () => ({
    $t: i18nMixin.methods.t,
    replaceSearchLabel: {
      // 변경할 라벨명
      'MULTINODE-GPU.clusterName': 'searchLabel.gpuClusterName',
      'DataOps.managerName': `searchLabel.dataOpsName`,
      'DataFlow.managerName': `searchLabel.dataFlowName`,
      'WAN.productName': `searchLabel.attachmentName`,
      'VM.productName': `searchLabel.productNameAndASG`,
      'WAN.productIdList': `searchLabel.attachmentName`
    },
    // dropbox값을 임시로 만들때..
    filterOptions: {
      // 'saType': ['Zookeeper', 'Broker', 'Zookeeper&Broker', 'AKHQ']
    },
    productFilter: {
      //필터 headers
      fields: []
    },
    filterHeaders: { fields: [] },
    tmpEventTableHeader: [], //테이블 임시,
    eventSetTableHeader: [],
    eventTableHeader: [], //테이블 headers,
    eventTableData: [],
    detailProjectEvent: {},
    RESULT_DETAIL_ERROR: null,
    RESULT_ERROR: null
  }),
  mutations: {
    SET_LIST_PRODUCTS_CONDITIONS(state, payload) {
      state.eventTableData = [];
      state.productFilter.fields = [];
      state.productFilter.fields = Object.keys(payload.searchList).map((key) => {
        const keyMap = {
          metricKeyList: 'metricName',
          productTags: 'tag'
        };
        let strLabel = state.$t(
          state.replaceSearchLabel[`${payload.searchList.productTypeCode}.${key}`] ||
            `searchLabel.${keyMap[key] || key}`
        );
        let item = {
          id: key,
          label: strLabel,
          model: key,
          isCounter: false
        };
        if (Array.isArray(state.filterOptions[key]) && !Array.isArray(payload.searchList[key])) {
          payload.searchList[key] = state.filterOptions[key];
        }

        if (Array.isArray(payload.searchList[key]) && payload.searchList[key].length) {
          if (key === 'eventState') {
            const allItemIndex = payload.searchList[key].findIndex((i) => i === 'ALL');
            if (allItemIndex > -1) payload.searchList[key].splice(allItemIndex, 1);
            payload.searchList[key] = payload.searchList[key].map((key) =>
              scpmUtil.capitalize(key)
            );
          }
          if (key === 'metricKeyList') {
            item['values'] = convertFlatMetricsToTree(payload.searchList[key], [], true);
          } else if (key === 'productTypeCodeList') {
            item['type'] = 'tree-checkbox-dropdown';
          } else {
            item['type'] = 'select';
            item['values'] = [
              ...payload.searchList[key].map((v) => {
                if (typeof v == 'object') {
                  return { key: v.id, value: v.name, text: v.name, ...v };
                }
                return { key: v, value: v, text: v };
              })
            ];
          }

          if (item.label === 'Attachment name' && item.id === 'productIdList') {
            item['type'] = 'input';
          }
        }
        return item;
      });

      state.tmpEventTableHeader = payload.returnList.map((key) => {
        const strLabel = state.$t(
          state.replaceSearchLabel[`${payload.searchList.productTypeCode}.${key}`] ||
            `searchLabel.${key}`
        );

        return {
          text: strLabel,
          value: key,
          key: key
        };
      });
    },
    // c-filter 헤더 정보 merge및 정렬
    SET_FILTER_HEADER_MERGE(state, payload) {
      state.filterHeaders.fields = state.productFilter.fields
        .map((h, i) => {
          let obj =
            payload.find((v, index) => {
              v['idx'] = index;
              return v.id === h.id;
            }) || {};

          if (obj.idx == undefined) {
            h['idx'] = i + 10;
            // 페이지에 검색필터 설정이 안되어 있을경우 input/select 검색필드 자동생성
            obj['width'] = '100%';
            if (typeof h.values != 'undefined' && Array.isArray(h.values)) {
              obj['type'] = 'select';
            } else {
              obj['type'] = 'input';
              obj['inputType'] = 'text';
            }
          }
          if (obj.type == 'input-search') {
            h.values.shift();
            h['type'] = 'input-search';
          }
          if (obj.type == 'select-box') {
            h['type'] = 'select-box';
          }
          if (obj.inputType == 'customArray') {
            h['values'] = obj['customArray'];
          }
          obj = { ...obj, ...h };
          //
          if (typeof obj.type == 'undefined') {
            obj['type'] = 'input';
            obj['inputType'] = 'text';
          }
          return obj;
        })
        .filter((item) => {
          return typeof item.disable === 'undefined' || item.disable !== true;
        });
      // .sort((a, b) => {
      //   return a.idx - b.idx;
      // });
    },
    // 테이블 해더 정보 보관
    SET_TABLE_HEADER(state) {
      state.eventSetTableHeader = state.tmpEventTableHeader;
    },
    // 테이블 헤더값 적용
    SET_TABLE_HEADER_MERGE(state, payload = []) {
      state.eventTableHeader = state.eventSetTableHeader.map((h, i) => {
        let obj =
          payload.find((v, index) => {
            v['idx'] = typeof v.idx == 'undefined' ? index + 10 : v.idx;
            return v.value == h.value;
          }) || {};

        if (obj.idx == undefined) {
          h['idx'] = i + 30;
          if (typeof obj['width'] == 'undefined') obj['width'] = 100;
          if (typeof obj['bodyAlign'] == 'undefined') obj['bodyAlign'] = 'center';
        }
        obj = { ...obj, ...h };
        if (obj['value'] === 'metricName') {
          obj['bodyAlign'] = 'left';
        }
        if (Array.isArray(state.eventTableData.sortableFields)) {
          obj['sortable'] = state.eventTableData.sortableFields.includes(h.value) ? true : false;
        }
        return obj;
      });
      // .sort((a, b) => {
      //     return a.idx - b.idx
      // })
    },
    SET_LIST_PROJECT_EVENTS(state, payload) {
      state.eventTableData = payload;
    },
    SET_DETAIL_PROJECT_EVENTS(state, payload) {
      state.detailProjectEvent = payload;
      state.RESULT_DETAIL_ERROR = null;
    },
    SET_DETAIL_EVENTS_ERROR(state, payload) {
      state.detailProjectEvent = {};
      state.RESULT_DETAIL_ERROR = payload;
    }
  },
  actions: {
    listProductsConditions({ commit }, params = { conditionType: 'metric', resourceType: 'VM' }) {
      return new Promise((resolve, reject) => {
        restManager
          .get(
            API.productsConditions + `?conditionType=${params.conditionType}`,
            null,
            true,
            false,
            { headers: { 'X-ResourceType': params.resourceType } }
          )
          .then((res) => {
            // =======================================================================
            // DO NOT MERGE THIS PIECE OF CODE
            // FOR TESTING
            const {
              searchList: { groupSqList }
            } = res;
            function* generateId(id = 0, key = '') {
              while (id < Math.pow(10, 4)) {
                id++;
                key = Array(3).fill(Math.random().toString(36).slice(2)).join('');
                if (!groupSqList.find((el) => el.id == id)) {
                  yield { id, key };
                }
              }
            }
            if (window.sessionStorage.mockUp == '1') {
              const t1 = new Date().getTime();
              const fakeId = generateId();
              const mockUpGroups = Array(150 - groupSqList.length)
                .fill(false)
                .map((_, index) => {
                  const { id, key } = fakeId.next().value;
                  return {
                    id: id,
                    name: `ASG_mocked_${index + 1}`,
                    groupIfKey: key
                  };
                });
              res.searchList.groupSqList = [...groupSqList, ...mockUpGroups];
              const t2 = new Date().getTime();
            }
            // =======================================================================
            res = handleSearchCondition(params, res);
            if (!Object.keys(res.searchList).includes('productTypeCode'))
              res.searchList['productTypeCode'] = params.resourceType;
            commit('SET_LIST_PRODUCTS_CONDITIONS', res);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    listProductsConditionsEventSetting({ commit }, params) {
      commit('SET_LIST_PRODUCTS_CONDITIONS', params);
    },
    /**
     * API : /monitoring/event/v1/console/events <<< params: {resourceType: 'VM', ...param}
     * @param {Object} payload
     * @returns
     */
    listProjectEvents({ commit }, payload = { productTypeCode: 'VM' }) {
      return new Promise((resolve, reject) => {
        restManager.event
          .post('/v1/console/events', payload, true, false, {
            headers: { 'X-ResourceType': payload.productTypeCode }
          })
          .then((data) => {
            data.contents.map((item) => {
              if (Array.isArray(item.productInfoAttrs)) {
                for (let v of item.productInfoAttrs) {
                  if (typeof item[v.attrName] == 'undefined') {
                    if (/^\[.+\]$/.test(v.attrValue)) {
                      let attr = /^\[(.+)\]$/.exec(v.attrValue);
                      item[v.attrName] = attr[1];
                    } else {
                      item[v.attrName] = v.attrValue;
                    }
                  }
                }
              }
            });
            commit('SET_LIST_PROJECT_EVENTS', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /****************************************************
     * 이벤트 설정
     ***************************************************/

    /***
     * 이벤트 설정 조회
     * @param payload
     */
    listEventPolicies({ commit }, payload = { productTypeCode: 'VM' }) {
      return new Promise((resolve, reject) => {
        restManager.event
          .post('/v1/console/event-policies', payload, true, false, {
            headers: { 'X-ResourceType': payload.productTypeCode }
          })
          .then((data) => {
            data.contents.map((content) => {
              if (Array.isArray(content.productInfoAttrs)) {
                for (let v of content.productInfoAttrs) {
                  if (typeof content[v.attrName] == 'undefined') {
                    if (/^\[.+\]$/.test(v.attrValue)) {
                      let attr = /^\[(.+)\]$/.exec(v.attrValue);
                      content[v.attrName] = attr[1];
                    } else {
                      content[v.attrName] = v.attrValue;
                    }
                  }
                }
              }
              (content.eventPolicies || []).map((eventPolice) => {
                eventPolice['productResourceId'] = content.productResourceId || '';
                if (typeof eventPolice.eventThreshold !== 'undefined') {
                  eventPolice.eventThreshold.metricFunction = 'NULL';
                }
              });
              return content;
            });
            commit('SET_LIST_PROJECT_EVENTS', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /***
     * /monitoring/event/v1/console/event-policies/{eventPolicyId}
     * 이벤트 상세
     * @param eventPolicyId 조회할 이벤트 정책 번호
     * @param resourceType 상품 유형코드
     */
    detailEventPolicy({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.event
          .get(`/v1/console/event-policies/${payload.eventPolicyId}`, null, true, false, {
            headers: { 'X-ResourceType': payload.resourceType }
          })
          .then((data) => {
            commit('SET_DETAIL_PROJECT_EVENTS', data);
            resolve(data);
          })
          .catch((e) => {
            commit('RESULT_DETAIL_ERROR', e);
            reject(e);
          });
      });
    },
    // 이벤트 설정 삭제
    deleteEventPolicies({ commit }, payload) {
      const { eventPolicyIds } = payload;
      return new Promise((resolve, reject) => {
        restManager.event
          .delete(`/v1/console/event-policies`, {}, eventPolicyIds, true, false, {
            headers: { 'X-ResourceType': payload.productTypeCode }
          })
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    /*
                                                                                                                                            이벤트 템플릿
                                                                
                                                                                                                                        */
    getEventPolicyTemplates({ commit }, payload) {},
    detailEventPolicyTemplate({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.event
          .get(`/v1/console/event-templates/${payload.seq}`, null, true, false, {
            headers: { 'X-ResourceType': payload.resourceType }
          })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /*
                                                                                                                                            이벤틀 필터링
                                                                
                                                                                                                                            eventFilteringName: 이벤트 필터링명
                                                                                                                                            productName       : 이벤트필터링 적용되 있는 모니터링 대상
                                                                                                                                            useYn             : 사용여부
                                                                                                                                            page              : 페이지번호  [required], 0
                                                                                                                                            size              : 출력개수    [required], 10
                                                                
                                                                                                                                        */
    listEventFilterings({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.event
          .get('/v1/console/event-filterings', payload)
          .then((res) => {
            if (Array.isArray(res.contents)) {
              res.contents.map((item) => {
                item.repetitionType = item.evtFltTerm.repetitionType;
              });
            }

            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    /*
                                                                                                                                            eventFilteringSq: 이벤트 필터링 Sq
                                                                                                                                        */
    detailEventFiltering({ commit }, payload) {
      const needHandleAuthorizationCheck = payload.needHandleAuthorizationCheck
        ? !!payload.needHandleAuthorizationCheck
        : false;

      return new Promise((resolve, reject) => {
        restManager.event
          .get(
            `/v1/console/event-filterings/${payload.eventFilteringSq}`,
            {},
            true,
            false,
            {},
            needHandleAuthorizationCheck
          )
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    // 필터추가
    createEventFiltering({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.event
          .post('/v1/console/event-filterings', payload, true, false, {}, false, ignoreErrors)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    updateEventFiltering({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.event
          .put(
            `/v1/console/event-filterings/${payload.eventFilteringSq}`,
            payload.body,
            true,
            false,
            {},
            false,
            ignoreErrors
          )
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    /*
                                                                                                                                        Path Parameters:<eventFilteringSq:이벤트 필터링 Sq>
                                                                                                                                        */
    deleteEventFiltering({ commit }, payload) {
      const needHandleAuthorizationCheck = payload.needHandleAuthorizationCheck
        ? !!payload.needHandleAuthorizationCheck
        : false;
      return new Promise((resolve, reject) => {
        restManager.event
          .delete(
            `/v1/console/event-filterings/${payload.eventFilteringSq}`,
            {},
            {},
            true,
            false,
            {},
            needHandleAuthorizationCheck
          )
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    /**
     * UTC기준
     * @param {
     *       startQueryDt: YYYYMMDDHH:mm,
     *       endQueryDt: YYYYMDDHH:mm
     *  }
     */
    listEventFilteringsByDate({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.event
          .get(
            '/v1/console/event-filterings/standard-date',
            payload,
            true,
            false,
            {},
            false,
            ignoreErrors
          )
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    }
  },
  getters: {}
};
